import { render, staticRenderFns } from "./pcb_upgerberfile.vue?vue&type=template&id=53ba497b&scoped=true&"
import script from "./pcb_upgerberfile.vue?vue&type=script&lang=js&"
export * from "./pcb_upgerberfile.vue?vue&type=script&lang=js&"
import style0 from "./pcb_upgerberfile.vue?vue&type=style&index=0&id=53ba497b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ba497b",
  null
  
)

export default component.exports